import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/sensitivity';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { goalId } = action?.payload || {};
    const response = yield call(
      axios.get,
      `${config.API_URL}/goals/${goalId}/scenarios/sensitivity`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response.data?.data?.sensitivity || null));
  } catch (error) {
    // Best-effort read on goal change: the page silently shows
    // "Not run yet" — no global error surface.
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
